import axiosInstance from "../../../../variables/api/axiosInstance";

export const baremeCapitalisation = async(ageLimite, age, sexe) => {
    return await axiosInstance.get(`/api/age-limite-paiement-rente/find-by-criteria/${ageLimite}/${age}/${sexe}`);
}